export default {
  ZH_HK: {
    title: "圖片信息聲明",
    source: "聲明來源",
    input: "輸入",
    information: "版權信息",
    confirm: "確定"
  },
  zh_cn: {
    title: "图片信息声明",
    source: "声明来源",
    input: "输入",
    information: "版权信息",
    confirm: "确定"
  },
  EN: {
    title: "Image Information Statement",
    source: "Source statement",
    input: "Input",
    information: "Copyright Information",
    confirm: "Confirm"
  }
};
